module.exports = __webpack_public_path__ + "media/images/tiedye/coral-aed69696187373ef4a2e1f6cc6d43d4c.jpg";